// extracted by mini-css-extract-plugin
export default {"checkbox":"jR1QV","align-items-center":"_3tq7C","alignItemsCenter":"_3tq7C","label":"_3ZCJh"};